/** Socket.IO wire event names (no Laravel namespace). */
const PBIS_POINTS_WIRE_EVENTS = Object.freeze([
  "PbisPointsAwarded",
  "PbisPointsRedeemed",
  "PbisPointsCorrected"
])

/** Laravel Echo private channel names (without `private-` prefix). */
const PBIS_POINTS_EVENT_ALIASES = Object.freeze({
  AWARDED: Object.freeze([
    ".PbisPointsAwarded",
    "PbisPointsAwarded",
    ".App.Events.Pbis.PbisPointsAwarded",
    "App\\Events\\Pbis\\PbisPointsAwarded"
  ]),
  REDEEMED: Object.freeze([
    ".PbisPointsRedeemed",
    "PbisPointsRedeemed",
    ".App.Events.Pbis.PbisPointsRedeemed",
    "App\\Events\\Pbis\\PbisPointsRedeemed"
  ]),
  CORRECTED: Object.freeze([
    ".PbisPointsCorrected",
    "PbisPointsCorrected",
    ".App.Events.Pbis.PbisPointsCorrected",
    "App\\Events\\Pbis\\PbisPointsCorrected"
  ])
})

/**
 * Wire event names as emitted by Laravel Echo Server (Socket.IO).
 * @returns {string[]}
 */
export function getPbisPointsWireEventNames() {
  return [...PBIS_POINTS_WIRE_EVENTS]
}

/**
 * @returns {string[]}
 */
export function getPbisPointsEventNames() {
  return [...new Set(Object.values(PBIS_POINTS_EVENT_ALIASES).flat())]
}

/**
 * @param {number | string} userId
 * @param {number | string} schoolId
 * @returns {string}
 */
export function buildStudentPbisPointsChannel(userId, schoolId) {
  return `user.pbis.points.${userId}.${schoolId}`
}

/**
 * @param {number | string} schoolId
 * @returns {string}
 */
export function buildSchoolPbisPointsChannel(schoolId) {
  return `school.pbis.points.${schoolId}`
}

export default {
  PBIS_POINTS_EVENT_ALIASES,
  PBIS_POINTS_WIRE_EVENTS,
  getPbisPointsEventNames,
  getPbisPointsWireEventNames,
  buildStudentPbisPointsChannel,
  buildSchoolPbisPointsChannel
}
